/*
 * @Author: llzq
 * @Date: 2021-01-12 15:54:45
 * @Email: liuzhiqiang1@jd.com
 * @LastEditors: llzq
 * @LastEditTime: 2021-10-24 18:49:51
 * @Description:  头部注释
 */
import React, { Component } from 'react'
import {Modal,Row,Col,Button} from "antd";
// img
import TeachEvaluaIcon from '@/assets/image/head/teachevalua.svg'
// model
import TodoDetails from '../../../notice/model/todoDetails'

import './style.less'

interface iProps {
    onCancel: () => void;
    deleteMessage: () => void;
    visible: boolean;
    todo: TodoDetails;
    finishTodo: () => void
}
export default class todoDetails extends Component<iProps> {
    onOk = () => {
    };
    toTask = () => {
        window.open(`${this.props.todo?.pcAction}`)
    }
    render() {
        const { visible, onCancel, todo, deleteMessage, finishTodo } = this.props
        return (
            <Modal
            width="480px"
            title="待办详情"
            visible={visible}
            onOk={this.onOk}
            onCancel={onCancel}
            footer={null}
            className="todoDetails"
            >
                <div className="todoDetails_content">
                    <div>
                        <img src={TeachEvaluaIcon} width="64" height="64" />
                    </div>
                    <Row className='mt16'>
                        <Col span={12}>
                            <span className="boldTitle">发布人：</span>{todo.systemName}
                        </Col>
                        <Col span={12}>
                            <span className="boldTitle">发布时间：</span>{todo.sendTime}
                        </Col>
                    </Row>
                    <div className="mt10">
                        <div className="boldTitle">待办内容：</div>
                        <div className="mt8">
                            {todo.content}
                        </div>
                    </div>
                    <div className="mt10">
                        <span className="boldTitle">截止时间：</span>
                        {todo.deadlineDate}
                    </div>
                    <div className="mt10">
                        <span className="boldTitle">完成程度：</span>
                        {todo.finishedState
                            && <span className="todoItem_status_done">已完成</span>
                        }
                        {!todo.finishedState
                            && <span className="todoItem_status_notdone">未完成</span>
                        }
                    </div>
                </div>
                <div className="todoDetails_footer">
                    <Button onClick={deleteMessage}>删除</Button>
                    {
                        !todo.finishedState &&
                        <Button type="primary" onClick={finishTodo}>完成</Button>
                    }
                    <Button type="primary" onClick={this.toTask}>跳转至任务页面</Button>
                </div>
            </Modal>
        )
    }
}
